module.exports = __webpack_public_path__ + "img/knzb-shop.d96656a3.webp";